<template>
  <MainLayout>
    <ContentPageHeader functionName="データベース管理" pageName="バックアップ・リストア">
    </ContentPageHeader>
    
    <div v-if="!isAdmin">
      <div class="alert alert-danger">
        <i class="fas fa-exclamation-triangle"></i>
        このページは管理者のみアクセスできます。
      </div>
    </div>

    <div v-if="isAdmin">
      <!-- バックアップセクション -->
      <div class="operation-section">
        <h4>データベースバックアップ</h4>
        <div class="form-field-container">
          <div class="action-buttons">
            <button class="btn btn-primary" @click="backupDatabase">バックアップ実行</button>
          </div>
        </div>
        
        <!-- バックアップ結果表示 -->
        <div class="result-section" v-if="backupResult">
          <h5>実行結果</h5>
          <div class="result-container" :class="{'success': backupResult.success, 'error': !backupResult.success}">
            <div class="result-message">{{ backupResult.message }}</div>
          </div>
        </div>
      </div>

      <!-- リストアセクション -->
      <div class="operation-section">
        <h4>データベースリストア</h4>
        <div class="form-field-container">
          <label class="form-label">バックアップファイル名</label>
          <div class="required-mark-container"></div>
          <div class="input-container">
            <input 
              type="text" 
              v-model="restoreFileName" 
              placeholder="リストアするファイル名を入力してください"
              class="form-control"
            />
          </div>
        </div>
        
        <!-- 操作ボタン -->
        <div class="action-buttons">
          <button class="btn btn-warning" @click="restoreDatabase" :disabled="!restoreFileName">リストア実行</button>
        </div>
        
        <!-- リストア結果表示 -->
        <div class="result-section" v-if="restoreResult">
          <h5>実行結果</h5>
          <div class="result-container" :class="{'success': restoreResult.success, 'error': !restoreResult.success}">
            <div class="result-message">{{ restoreResult.message }}</div>
          </div>
        </div>
      </div>
      <!-- CloudFlareセクション -->
      <!-- データ移行以外の場合は表示しない -->
      <div class="operation-section">
        <h4>CloudFlare一括画像アップロード</h4>
        <div class="form-field-container">
          <div class="action-buttons">
            <button class="btn btn-primary" @click="allImageUpload">アップロード実行</button>
          </div>
        </div>
        <!-- バックアップ結果表示 -->
        <div class="result-section" v-if="allImageUploadResult">
          <h5>実行結果</h5>
          <div class="result-container" :class="{'success': allImageUploadResult.success, 'error': !allImageUploadResult.success}">
            <div class="result-message">{{ allImageUploadResult.message }}</div>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layout/MainLayout.vue'
import ContentPageHeader from '@/components/layout/ContentPageHeader.vue'
import service from '../../services/service'
import constants from '../../constants/constants.json'

export default {
  name: 'DatabaseBackupView',
  components: {
    MainLayout,
    ContentPageHeader
  },
  data() {
    return {
      restoreFileName: '',
      backupResult: null,
      restoreResult: null,
      allImageUploadResult: null
    }
  },
  computed: {
    isAdmin() {
      const user = this.$store.getters['auth/currentUser'];
      return user && user.authority === constants.Authority.ADMIN.id;
    }
  },
  methods: {
    async backupDatabase() {
      try {
        this.backupResult = null;
        const response = await service.backupDatabase();
        this.backupResult = {
          success: true,
          message: response.data || 'データベースバックアップが正常に完了しました。'
        };
      } catch (error) {
        this.handleBackupError(error);
      }
    },
    
    async restoreDatabase() {
      try {
        this.restoreResult = null;
        const response = await service.restoreDatabase(this.restoreFileName);
        this.restoreResult = {
          success: true,
          message: response.data || 'データベースリストアが正常に完了しました。'
        };
      } catch (error) {
        this.handleRestoreError(error);
      }
    },

    async allImageUpload() {
      // 確認ダイヤログの表示
      if (!confirm('CloudFlareに全ての画像をアップロードします。よろしいですか？')) {
        return;
      }
      try {
        service.allImageUpload();
        this.allImageUploadResult = {
          success: true,
          message: 'CloudFlare一括画像アップロードを開始しました。処理には時間がかかる場合があります。'
        };
      } catch (error) {
        this.handleAllImageUploadResult(error);
      }
    },
    
    handleBackupError(error) {
      console.error('データベースバックアップエラー:', error);
      this.backupResult = {
        success: false,
        message: error.response?.data || 'バックアップの実行に失敗しました'
      };
    },
    
    handleRestoreError(error) {
      console.error('データベースリストアエラー:', error);
      this.restoreResult = {
        success: false,
        message: error.response?.data || 'リストアの実行に失敗しました'
      };
    },
    
    handleAllImageUploadResult(error) {
      console.error('CloudFlare一括画像アップロードエラー:', error);
      this.allImageUploadResult = {
        success: false,
        message: error.response?.data || 'CloudFlare一括画像アップロードの実行に失敗しました'
      };
    }
  }
}
</script>

<style scoped>
.operation-section {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.form-field-container {
  margin-bottom: 20px;
}

.form-label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

.input-container {
  max-width: 400px;
}

.action-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.result-section {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  margin-top: 15px;
}

.result-container {
  padding: 15px;
  border-radius: 5px;
  margin-top: 10px;
}

.success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
}

.error {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

.result-message {
  font-weight: bold;
  margin-bottom: 10px;
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
